import type { Engine } from '../types';
import { buildUrl } from '../url';

export const chatgpt: Engine = {
  id: 'chatgpt',
  name: 'ChatGPT',
  bang: 'gpt',
  aliases: ['chatgpt'],
  homepage: 'https://chatgpt.com',
  category: 'AI',
  defaultOn: true,
  description: 'Sends your query as a prompt.',
  params: [
    {
      id: 'draft',
      type: 'flag',
      token: 'draft',
      label: 'Fill in without sending',
      group: 'Options',
      help: 'Opens with the prompt typed so you can edit it first.',
    },
  ],
  build({ query, values }) {
    return buildUrl(
      'https://chatgpt.com/',
      values.draft === true ? { prompt: query } : { q: query }
    );
  },
};

export const claude: Engine = {
  id: 'claude',
  name: 'Claude',
  bang: 'claude',
  aliases: ['cla'],
  homepage: 'https://claude.ai',
  category: 'AI',
  description: 'Starts a new chat with your query filled in.',
  signIn: 'Needs you signed in to Claude.',
  params: [],
  build({ query }) {
    return buildUrl('https://claude.ai/new', { q: query });
  },
};

export const perplexity: Engine = {
  id: 'perplexity',
  name: 'Perplexity',
  bang: 'pplx',
  aliases: ['perplexity'],
  homepage: 'https://www.perplexity.ai',
  category: 'AI',
  description: 'Asks your query and shows a cited answer.',
  params: [],
  build({ query }) {
    return buildUrl('https://www.perplexity.ai/search', { q: query });
  },
};
